import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as qs from 'querystring';
import axios from 'axios';
import * as htmlParse from 'cheerio';
import LoadingOverlay from 'react-loading-overlay';
import ReactToolTip from 'react-tooltip';
import error from './images/error.svg';
import logo from './images/targetx_green_x.png';
import '../styles/ind_act_cust.css';

class Ind_Activity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: [],
      loading: false,
      sending: false,
      resent: false,
      current_message: '',
      update_timestamp: '',
      get_error: false,
      post_error: false,
      error_response: '',
      url_query: {},
      resend_enabled: true,
    };
    this.sf_link = this.sf_link.bind(this);
    this.preview_email = this.preview_email.bind(this);
    this.resend_email = this.resend_email.bind(this);
  }

  // Life Cycle Methods
  // Mounting operatiions
  componentDidMount() {
    this.getActivity();
  }

  // Updating operations
  shouldComponentUpdate(nextProps, nextState) {
    // Will not trigger render() if returns false
    if (
      this.state.loading !== nextState.loading ||
      this.state.get_error !== nextState.get_error ||
      this.state.post_error !== nextState.post_error ||
      this.state.resend_enabled !== nextState.resend_enabled ||
      this.state.resent !== nextState.resent ||
      this.state.sending !== nextState.sending ||
      this.state.result !== nextState.result
    ) {
      return true;
    }
    return false;
  }

  async getActivity() {
    this.setState({ loading: true });
    const { location } = this.props;

    try {
      const queryObject = qs.parse(location.search.split('?')[1]);
      const response = await axios(`/ind_activity/${location.search}`);
      const formattedTime = new Date(Date.now()).toLocaleString();

      if (response.status === 204) {
        this.setState({
          loading: false,
          update_timestamp: formattedTime,
        });
      } else {
        this.setStateFromResponse(formattedTime, queryObject, response.data);
      }
    } catch (error) {
      this.setErrorState(error);
    }
  }

  async preview_email(details) {
    // const message_serial = details[1]['send_message'];
    const url_params = new URLSearchParams(window.location.search);
    const header_obj = {
      'session-id': url_params.get('session_id'),
      instance: url_params.get('sf_location'),
      orgId: url_params.get('org'),
    };
    const config = {
      headers: header_obj,
    };
    const preview_obj = {};
    preview_obj.client_id = details[1].client_id;
    preview_obj.campaign_id = details[1].campaignID;
    preview_obj.broadcast_id = details[0];
    preview_obj.recipient_id = details[1].con_lead_id;
    const preview_results = await axios.post('/preview/', preview_obj, config).catch(error => {
      this.setState({
        post_error: true,
        error_response: error.response.data,
        loading: false,
      });
    });
    if (!this.state.post_error) {
      const preview_content = preview_results.data.content;
      for (const view in preview_content) {
        if (preview_content[view].type === 'text/html') {
          const preview_html = htmlParse.load(preview_content[view].value);
          const win = window.open(
            '',
            'ViewWindow1',
            'scrollbars=yes,resizable=yes,toolbar=no, height=500, width=780',
          );
          win.document.open();
          win.document.write(preview_html.html());
          win.document.close();
        }
      }
    }
  }

  async resend_email(details, index) {
    const url_params = new URLSearchParams(window.location.search);
    const header_obj = {
      'session-id': url_params.get('session_id'),
      instance: url_params.get('sf_location'),
      orgId: url_params.get('org'),
    };
    const config = {
      headers: header_obj,
    };
    const resend_obj = {};
    resend_obj.client_id = details[1].client_id;
    resend_obj.campaign_id = details[1].campaignID;
    resend_obj.broadcast_id = details[0];
    resend_obj.recipient_id = details[1].con_lead_id;
    let new_result_state = [...this.state.result];
    new_result_state[index][1]['resend_attempt'] = true;
    this.setState({ sending: true, current_message: details[1].send_message, result: new_result_state });
    const response = await axios.post('/resend/', resend_obj, config).catch(error => {
      new_result_state[index][1]['post_error'] = true;
      new_result_state[index][1]['error_response'] = error.response.data;
      this.setState({
        result: new_result_state,
        sending: false,
        resent: false,
      });
    });
    if (!this.state.post_error) {
      this.setState({ sending: false, resend_response: response });
    }
  }

  sf_link(detail) {
    const broadcast_id = detail[0];
    const { sf_location } = this.state.url_query;
    const url = `${sf_location.slice(0, sf_location.indexOf('.com') + 4)}/${broadcast_id}`;
    window.open(url, 'ViewWindow1', 'scrollbars=yes,resizable=yes,toolbar=no,height=500,width=780');
  }

  setErrorState(error) {
    this.setState({
      get_error: true,
      error_response: error.response.data,
      loading: false,
    });
  }

  setStateFromResponse(formattedTime, queryObject, responseData) {
    const { broadcasts, resend_enabled } = responseData;

    this.setState({
      resend_enabled,
      loading: false,
      result: broadcasts,
      update_timestamp: formattedTime,
      url_query: queryObject,
    });
  }

  render() {
    const {
      result,
      loading,
      update_timestamp,
      sending,
      current_message,
      resend_enabled,
      get_error,
    } = this.state;
    const loading_dots = (
      <div className="loading-horizontal">
        <div className="loading-horizontal__item"></div>
        <div className="loading-horizontal__item"></div>
        <div className="loading-horizontal__item"></div>
      </div>
    );
    return (
      <LoadingOverlay
        active={sending}
        spinner={loading_dots}
        text="Processing your request..."
        styles={{
          overlay: (base) => ({
            ...base,
            position: 'fixed'
          })
        }}
      >
        <div>
          {loading ? (
            <div className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <p>Loading Stats...</p>
            </div>
          ) : (
            <div className="pbSubsection">
              <h3 className="eca">Recipient Broadcast Activity</h3>
              <table className="detailList">
                <thead>
                  <tr>
                    <td className="iir-col1">
                      <span className="col-header">Campaign</span>
                    </td>
                    <td className="iir-col2">
                      <span className="col-header">Date/Time</span>
                    </td>
                    <td className="iir-col3">
                      <span className="col-header">Received</span>
                    </td>
                    <td className="iir-col4">
                      <span className="col-header">View</span>
                    </td>
                    <td className="iir-col5">
                      <span className="col-header">Interact</span>
                    </td>
                    <td className="iir-col6">
                      <span className="col-header">Profile Update</span>
                    </td>
                    <td className="iir-col7">
                      <span className="col-header">Opt Out</span>
                    </td>
                    <td className="iir-col8">
                      <span className="col-header">Message</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  { ( result.length >= 1 && !get_error )
                    ? result.map((res, index) => (
                      <tr key={res[1].send_message}>
                        <td className="iir-col1">
                          <a id="clicktoseelist" onClick={() => this.sf_link(res)}>
                            {res[1].name}
                          </a>
                          <br />
                          <br />
                        </td>
                        <td className="iir-col2">
                          {new Date(res[1].cdate).toLocaleString('en-US', { hour12: false })}
                          <br />
                        </td>
                      <td className="iir-col3">
                        <span style={{ 'color': res[1].b_or_r === '\u2718' ? '#FF0000' : '#00A216' }}>{res[1].b_or_r}</span>
                      </td>
                      <td className="iir-col4">
                        <span style={{ 'color': res[1].html === '\u2718' ? '#FF0000' : '#00A216' }}>{res[1].html}</span>
                      </td>
                      <td className="iir-col5">
                        <span style={{ 'color': res[1].interact === '\u2718' ? '#FF0000' : '#00A216' }}>{res[1].interact}</span>
                      </td>
                      <td className="iir-col6">
                        <span style={{ 'color': res[1].profile === '\u2718' ? '#FF0000' : '#00A216' }}>{res[1].profile}</span>
                      </td>
                      <td className="iir-col7">
                        <span style={{ 'color': res[1].optout === '\u2718' ? '#FF0000' : '#00A216' }}>{res[1].optout}</span>
                      </td>
                        {resend_enabled ? (
                          <td className="iir-col8">
                            <a id="clicktoseelist" onClick={() => this.preview_email(res)}>
                              View
                            </a>
                            <span> | </span>
                            {sending && current_message === res[1].send_message
                              ? <a className="disabledCursor" onClick={(event) => event.preventDefault()}>Resending...</a>
                              : !sending && (res[1]['resend_attempt'] === true)
                                ? <a className="disabledCursor" onClick={(event) => event.preventDefault()}>Resent</a>
                                : <a id="clicktoseelist" onClick={() => this.resend_email(res, index)}>Resend</a>}
                            <div>
                              {res[1].post_error === true ? (
                                <span>
                                  <a data-tip data-for="resend-error"><img src={error} style={{height: '1em', paddingLeft: '10px'}} alt="tool-tip" /></a>
                                  <ReactToolTip id="resend-error" type="error" place="left">
                                    <p>We were unable to resend your message, please try again.</p>
                                  </ReactToolTip>
                                </span>
                              ) : null}
                            </div>
                            <div>
                              {res[1].resend !== undefined ? (
                                <span>
                                    Date resent :
                                  {' '}
                                  {new Date(res[1].resend).toLocaleDateString('en-US')}
                                </span>
                              ) : null}
                            </div>
                            <br />
                          </td>
                        ) : (
                          <a id="clicktoseelist" onClick={() => this.preview_email(res)}>
                              View
                          </a>
                        )}
                      </tr>
                    ))
                    : ( result.length < 1 && !get_error ) ? null : (
                      <tr>
                        <td><span style={{ 'text-align': 'center' }}>There was an issue retrieving the historical data for this recipient, please contact TargetX support.</span></td>
                      </tr>
                    )}
                </tbody>
              </table>
              <div style={{ float: 'left', paddingLeft: '14px' }}>
                <span>
                  Last Updated at:
                  {' '}
                  {update_timestamp}
                </span>
              </div>
            </div>
          )}
        </div>
      </LoadingOverlay>
    );
  }
}

Ind_Activity.propTypes = {
  location: PropTypes.object,
};

export default Ind_Activity;



// WEBPACK FOOTER //
// ./src/client/views/ind_activity.js